import useComponentRefsStore from '@/packages/plugins/stores/componentRefs'

const registerWhiteList = [
  'xy-lucky-wheel',
  'xy-lucky-grid',
  'xy-lucky-grid-two',
  'xy-raffle',
  'xy-lucky-btn',
  'xy-list-item-layout',
  'xy-swiper',
  'xy-survey-form',
  'xy-survey-btn',
  'xy-goods-tips',
  'xy-double-faced-image',
  'xy-raffle-btn',
  'xy-treasure-btn',
  'xy-world-cup-btn',
  'xy-input'
]

const useComponentRef = () => {
  const componentRefsStore = useComponentRefsStore()

  const setComponentRef = (name, uuid, el) => {
    if (!uuid || !el) return
    if (!registerWhiteList.includes(name)) return
    componentRefsStore.setComponentRefs(uuid, el)
  }

  const getComponentRef = (uuid) => {
    if (!uuid) return
    return componentRefsStore.getComponentRefs(uuid)
  }

  return {
    setComponentRef,
    getComponentRef
  }
}

export default useComponentRef
